{
  "id": "icons-care",
  "class": "icon",
  "size": {
    "w": 16,
    "h": 16
  },
  "anchor": {
    "x": 8,
    "y": 8
  },
  "palette": {
    "k": "#23140b",
    "o": "#d8742a",
    "O": "#f0a04a",
    "d": "#a34a1c",
    "c": "#dcc096",
    "C": "#efe0c2",
    "s": "#b89062",
    "y": "#e6b832",
    "Y": "#f7d969",
    "g": "#be7934",
    "r": "#a82c2c",
    "R": "#cf4a4a",
    "D": "#731c1c",
    "p": "#d9687e",
    "P": "#ad4459",
    "b": "#4a78b0",
    "B": "#7aa8d8",
    "u": "#2c4a7a",
    "m": "#6f4f9a",
    "M": "#9a7bc4",
    "U": "#4a3066"
  },
  "frames": {
    "food": [
      "................",
      "................",
      "......kkkk......",
      "....kkOOOOkk....",
      "...kOOOOOoodk...",
      "..kOOOOooodddk..",
      "..koOOoooddddk..",
      ".kkkkkkkkkkkkkk.",
      ".kCccccccccccsk.",
      "..kccccccccssk..",
      "..kccccccccssk..",
      "...kccccccsskk..",
      "....kkkkkkkk....",
      "................",
      "................",
      "................"
    ],
    "play": [
      "................",
      "................",
      "......kkkk......",
      "....kkYYrrkk....",
      "...kYYYkrrrkk...",
      "..kYYYYkrrrrDk..",
      "..kYYyykrrrrDk..",
      "..kkkkkkkkkkkk..",
      "..kBBbbkccccsk..",
      "..kBBbbkcccssk..",
      "...kBbbkcsskk...",
      "....kkbbkskk....",
      "......kkkk......",
      "................",
      "................",
      "................"
    ],
    "rest": [
      "................",
      "................",
      "......kkkk......",
      "....kkMMMMkk....",
      "...kMMMMmmkk....",
      "..kMMMMmmk......",
      "..kMMmmmmk......",
      ".kMMmmmmk.......",
      ".kMmmmmk........",
      "..kmmmmUk.......",
      "..kmmmUUUkk.....",
      "...kmmUUUUUkk...",
      "....kkkUUUUkk...",
      "......kkkkk.....",
      "................",
      "................"
    ],
    "wash": [
      "................",
      "................",
      ".......kk.......",
      "......kBBk......",
      ".....kBBbbk.....",
      "....kBBbbbbk....",
      "...kBBbbbbbbk...",
      "..kBBbbbbbbbuk..",
      "..kBbbbbbbbuuk..",
      "..kbbbbbbbbuuk..",
      "..kbbbbbbbbuuk..",
      "...kbbbbbbuuk...",
      "....kkkbuukkk...",
      "......kkkk......",
      "................",
      "................"
    ],
    "love": [
      "................",
      "................",
      "...kkk....kkk...",
      "..kppRk..kRRrk..",
      ".kppRRrkkrRRrrk.",
      ".kpRRrrrrrrrrDk.",
      ".kRRrrrrrrrrrDk.",
      ".kRrrrrrrrrrrDk.",
      "..krrrrrrrrrDk..",
      "...krrrrrrrDk...",
      "....krrrrrDk....",
      ".....krrrDk.....",
      "......krDk......",
      ".......kk.......",
      "................",
      "................"
    ]
  }
}
